import { WithChildren } from "_metronic/helpers";

export type WizardStepperFooterProps = {
  children: React.ReactNode;
};

export const WizardStepperFooter: React.FC<WithChildren> = ({ children }) => {
  return <div className="mt-4 card-footer">{children}</div>;
};
